<script lang="ts">
  type Input = {
    id: string;
    className?: string;
    type?: string;
    required?: boolean;
    label?: string;
    placeholder?: string;
    description?: string;
    maxlength?: number;
    disabled?: boolean;
    error?: string;
    value?: string;
    updated?: (e: Event) => void;
    changed?: (e: Event) => void;
  };

  let {
    id = '',
    className = '',
    type = 'text',
    required = false,
    label = '',
    placeholder = '',
    description = '',
    disabled = false,
    error = '',
    value = '',
    updated,
    changed
  } = $props();
</script>

<div class={`up-form-element ${id} ${type} ${className} ${error ? 'error' : ''}`}>
  {#if label}
    <label for={id}>
      {@html label}
      {#if required}
        <span class="required">*</span>
      {:else}
        <span class="optional">(optional)</span>
      {/if}
    </label>
  {/if}
  {#if description}
    <p class="up-form-element__description">{description}</p>
  {/if}
  <div class="up-custom-input icon-right">
    <input
      {type}
      {id}
      name={id}
      {placeholder}
      class="{className} {disabled ? 'disabled' : ''} {error ? 'error' : ''}"
      {disabled}
      {required}
      onkeyup={updated}
      onchange={changed}
      bind:value
    />
  </div>
  {#if error.length > 0}
    <div class="up-form-element__validation-message">{error}</div>
  {/if}
</div>
